export default __webpack_public_path__ + "static/media/walk-the-moon.4426ba2b.png";